module.exports = __webpack_public_path__ + "img/issuing-sample-process-1.86eb6c81.png";